// extracted by mini-css-extract-plugin
module.exports = {"component":"livestream-event-LivestreamEventParticipants__component--veYI9"};